import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MarkAsteriskDirective } from 'common/directive/mark-asterisk.directive';

@NgModule({
  declarations: [
    MarkAsteriskDirective
  ],
  imports: [
    CommonModule,
  ],
  exports: [MarkAsteriskDirective],
  providers: []
})
export class CommonSharedModule { }
